import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './GiftCardBanner.scss';
import { compose } from 'recompose';
import { withExperiment } from '@sparefoot/react-core/decorators';

const enhance = compose(withExperiment('sf_15309_giftcard_incentives')) // sf_15309_giftcard_incentives
const GiftCardBanner = ({className, content, sf15309Variation}) => {
	return sf15309Variation === 'variation' ? // sf_15309_giftcard_incentives
	(
		<div className={classnames('gift-card-banner', className)}>
			{content}
		</div>
	):
	<></>;
};

GiftCardBanner.propTypes = {
	className: PropTypes.string,
	content: PropTypes.any,
	sf15309Variation: PropTypes.string,
};

GiftCardBanner.defaultProps = {
	className: '',
};

export default enhance(GiftCardBanner);
